export default __webpack_public_path__ + "static/media/duitnow.044b91b1.svg";